import { render, staticRenderFns } from "./UserDetailPop.vue?vue&type=template&id=37ef1013&scoped=true&"
import script from "./UserDetailPop.vue?vue&type=script&lang=js&"
export * from "./UserDetailPop.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=37ef1013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef1013",
  null
  
)

export default component.exports